import { render } from "./TeamDetails.vue?vue&type=template&id=6719a8bd"
import script from "./TeamDetails.vue?vue&type=script&lang=js"
export * from "./TeamDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__